'use strict';

import controller from './button.controller';
import template from './button.html';

const ButtonTimelineComponent = {
  bindings:{
    proyecto: '<'
  },
  controller,
  template
};

export default ButtonTimelineComponent;



// WEBPACK FOOTER //
// ./src/app/components/admin/timeline/button.component.js